/**
 * EmailPopup.validation.js
 *
 * Pure function, no React. Per FSD Field-Level Validation Summary:
 * "Email (popup) — Valid email format — 'Please enter a valid email
 * address.'" Email is required if submitting (the popup can't be
 * submitted empty, though the whole popup itself is optional/dismissable
 * — UC-05's PDF download works without ever opening it).
 */

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateEmailPopup(data) {
  const errors = {};

  if (!data.email || !data.email.trim()) {
    errors.email = "Please enter your email address.";
  } else if (!EMAIL_PATTERN.test(data.email.trim())) {
    errors.email = "Please enter a valid email address.";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}
